import type {EditCustomerOfferNoteFormPayload} from "./edit-customer-offer-note.schema";
import {editCustomerOfferNote} from "@project/sdk/sales";
import {EditCustomerOfferNoteResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../../../customerOffer-keys";
import {editCustomerOfferNoteFormSchema} from "./edit-customer-offer-note.schema";

export function editCustomerOfferNoteMutationOptions(id: string, noteId: number) {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.editCustomerOfferNote,
    mutationFn: async (payload: EditCustomerOfferNoteFormPayload) =>
      EditCustomerOfferNoteResponse.parse(
        await editCustomerOfferNote(id, noteId, editCustomerOfferNoteFormSchema.parse(payload)),
      ),
    onSuccess: async (_result, _variables, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(id)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
